import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const bluewaterBayMetadata = {
  id: 'bluewater-bay',
  name: 'Bluewater Bay',
  description:
    'A lush tropical resort routing around bright lakes, canals and inviting but exacting peninsula greens.',
  environmentPreset: 'noon',
  metadata: {
    location: 'Azure Key, Gulf Coast',
    regionType: 'tropical water resort',
    difficulty: 74,
    typicalWind: [5, 14] as const,
    greenSpeed: [10, 10.5] as const,
    firmness: 'soft' as const,
    primaryChallenge: 'Forced carries and safe-versus-aggressive water routes',
    signatureHoles: [6, 9, 14, 18],
    tournamentEventId: 'event-4',
    previewTheme: 'tropical-lagoon',
    environmentPalette: {
      fairway: '#38a05a',
      rough: '#17683f',
      bunker: '#f1e2b5',
      water: '#159fc1',
      haze: '#caeef1',
    },
    vegetationStyle: 'palms, mangroves and flowering tropical understory',
    terrainStyle: terrainPreset('lagoon-shelves', 4, 150, 0.9).id,
  },
};
const pars = [4, 5, 4, 3, 4, 3, 4, 5, 5, 4, 3, 4, 4, 5, 3, 4, 4, 4],
  yards = [
    390, 535, 425, 165, 405, 155, 445, 560, 525, 410, 180, 390, 450, 565, 195, 420, 455, 430,
  ],
  names = [
    'Welcome Water',
    'Palm Reach',
    'Canal Bend',
    'Frangipani',
    'Lagoon Run',
    'Island Jewel',
    'Blue Edge',
    'Two Shores',
    'Split Decision',
    'Marina',
    'Trade Wind',
    'Mangrove',
    'Lake Line',
    'Bay Route',
    'Heron',
    'Resort Turn',
    'Peninsula Road',
    'Bluewater Point',
  ];
const o: Partial<HolePlan>[] = [];
[1, 3, 5, 7, 8, 10, 12, 13, 17].forEach(
  (i, j) => (o[i] = { water: j % 3 === 0 ? 'carry' : j % 3 === 1 ? 'left' : 'green' }),
);
o[5] = { water: 'green', greenRadius: 20 };
o[8] = { water: 'left', splitFairway: true, landingZones: [{ distance: 275, width: 65 }] };
o[12] = { water: 'right' };
o[17] = { water: 'green', greenRadius: 19 };
export const createBluewaterBayDocument = () =>
  authorCourse({ ...bluewaterBayMetadata, plans: plans(names, pars, yards, o) });
